import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Notificaations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schoolinfo: {},
      lastmonthincome: "",
      lastmonthexpense: "",
      incomesum: "",
      expensesum: "",
      accountstat: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.fetch({ school: this.props.user.school });
    this.fetchlastmonthincome({});
    this.fetchlastmonthexpense({ school: this.props.user.school });
    this.fetchincomesum({ school: this.props.user.school });
    this.fetchexpensesum({ school: this.props.user.school });
    this.fetchaccountstat();
    this.fetchyearsellpaidamount();
    this.fetchcollectedfee();
    this.fetchyearreceivepaidamount({});
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });
    axios.get(`/api/studentcount`, { params: { ...params } }).then((res) => {
      this.setState({ studentdata: res.data });
    });
  };

  fetchlastmonthincome = (params = {}) => {
    axios
      .get(`/api/lastmonthincomeexpense`, { params: { ...params } })
      .then((res) => {
        this.setState({ lastmonthincome: res.data.income.ammount__sum });
      });
  };
  fetchlastmonthexpense = (params = {}) => {
    axios
      .get(`/api/lastmonthincomeexpense`, { params: { ...params } })
      .then((res) => {
        this.setState({ lastmonthexpense: res.data.expense.ammount__sum });
      });
  };
  fetchincomesum = (params = {}) => {
    axios
      .get(`/api/incomeexpensesum?item_action=receive`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          incomesum: res.data.income.ammount__sum,
        });
      });
  };
  fetchexpensesum = (params = {}) => {
    axios
      .get(`/api/incomeexpensesum?item_action=receive`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          expensesum: res.data.expense.ammount__sum,
        });
      });
  };

  fetchschool = (params = {}) => {
    axios
      .get(`/api/school/${this.props.user.school}`, { params: { ...params } })
      .then((res) => {
        this.setState({ schoolinfo: res.data });
      });
  };

  fetchaccountstat = (params = {}) => {
    axios
      .get(`/api/accountcount`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          month_income: res.data.month_income.ammount__sum,
          week_income: res.data.week_income.ammount__sum,
          today_income: res.data.today_income.ammount__sum,
          sixmonth_income: res.data.sixmonth_income.ammount__sum,
          year_income: res.data.year_income.ammount__sum,
          month_expense: res.data.month_expense.ammount__sum,
          week_expense: res.data.week_expense.ammount__sum,
          today_expense: res.data.today_expense.ammount__sum,
          sixmonth_expense: res.data.sixmonth_expense.ammount__sum,
          year_expense: res.data.year_expense.ammount__sum,
        });
      });
  };

  fetchyearsellpaidamount = (params = {}) => {
    axios
      .get(`/api/itemsellamountcount`, { params: { ...params } })
      .then((res) => {
        this.setState({
          year_sell_paidamount: res.data.year_sell_paidamount.amount_paid__sum,
          sixmonth_sell_paidamount:
            res.data.sixmonth_sell_paidamount.amount_paid__sum,
          month_sell_paidamount:
            res.data.month_sell_paidamount.amount_paid__sum,
          today_sell_paidamount:
            res.data.today_sell_paidamount.amount_paid__sum,
          week_sell_paidamount: res.data.week_sell_paidamount.amount_paid__sum,
          year_sell_totalamount:
            res.data.year_sell_totalamount.total_amount__sum,
          sixmonth_sell_totalamount:
            res.data.sixmonth_sell_totalamount.total_amount__sum,
          month_sell_totalamount:
            res.data.month_sell_totalamount.total_amount__sum,
          today_sell_totalamount:
            res.data.today_sell_totalamount.total_amount__sum,
          week_sell_totalamount:
            res.data.week_sell_totalamount.total_amount__sum,
          sell_total_paid: res.data.total_paid.amount_paid__sum,
          sell_total: res.data.total.total_amount__sum,
        });
      });
  };

  fetchyearreceivepaidamount = (params = {}) => {
    axios
      .get(`/api/itemreceiveamountcount`, { params: { ...params } })
      .then((res) => {
        this.setState({
          year_receive_paidamount:
            res.data.year_receive_paidamount.amount_paid__sum,
          sixmonth_receive_paidamount:
            res.data.sixmonth_receive_paidamount.amount_paid__sum,
          month_receive_paidamount:
            res.data.month_receive_paidamount.amount_paid__sum,
          today_receive_paidamount:
            res.data.today_receive_paidamount.amount_paid__sum,
          week_receive_paidamount:
            res.data.week_receive_paidamount.amount_paid__sum,
          loading: false,
        });
      });
  };

  fetchcollectedfee = (params = {}) => {
    axios
      .get(`/api/collectedfee`, {
        params: { ...params },
      })
      .then((res) => {
        this.setState({
          todaycollectedfee: res.data.today_collected_fee.amount_paid__sum,
          lastweekcollectedfee: res.data.week_collected_fee.amount_paid__sum,
          lastmonthcollectedfee:
            res.data.currentmonth_collected_fee.amount_paid__sum,
          halfyearlycollectedfee:
            res.data.sixmonth_collected_fee.amount_paid__sum,
          yearlycollectedfee: res.data.year_collected_fee.amount_paid__sum,
        });
      });
  };
  render() {
    const {
      loading,

      month_income,
      week_income,
      today_income,
      sixmonth_income,
      year_income,
      month_expense,
      week_expense,
      today_expense,
      sixmonth_expense,
      year_expense,

      year_sell_paidamount,
      sixmonth_sell_paidamount,
      month_sell_paidamount,
      week_sell_paidamount,
      today_sell_paidamount,

      todaycollectedfee,
      lastweekcollectedfee,
      lastmonthcollectedfee,
      halfyearlycollectedfee,
      yearlycollectedfee,

      year_receive_paidamount,
      sixmonth_receive_paidamount,
      month_receive_paidamount,
      week_receive_paidamount,
      today_receive_paidamount,
    } = this.state;

    const dataIncome = [
      {
        name: "Today's Income",
        expence: `${
          Number(today_income) +
          Number(today_sell_paidamount) +
          Number(todaycollectedfee)
        }`,
      },
      {
        name: "Last 7 days Income",
        expence: `${
          Number(week_income) +
          Number(week_sell_paidamount) +
          Number(lastweekcollectedfee)
        }`,
      },
      {
        name: "Current Month Income",
        expence: `${
          Number(month_income) +
          Number(month_sell_paidamount) +
          Number(lastmonthcollectedfee)
        }`,
      },
      {
        name: "Last 6 Month Income",
        expence: `${
          Number(sixmonth_income) +
          Number(sixmonth_sell_paidamount) +
          Number(halfyearlycollectedfee)
        }`,
      },
      {
        name: "Current Year Income",
        expence: `${
          Number(year_income) +
          Number(year_sell_paidamount) +
          Number(yearlycollectedfee)
        }`,
      },
    ];

    const dataExpense = [
      {
        name: "Today's Expense",
        expence: `${Number(today_expense) + Number(today_receive_paidamount)}`,
      },
      {
        name: "Last 7 days Expense",
        expence: `${Number(week_expense) + Number(week_receive_paidamount)}`,
      },
      {
        name: "Current Month Expense",
        expence: `${Number(month_expense) + Number(month_receive_paidamount)}`,
      },
      {
        name: "Last 6 Month Expense",
        expence: `${
          Number(sixmonth_expense) + Number(sixmonth_receive_paidamount)
        }`,
      },
      {
        name: "Current Year Expense",
        expence: `${Number(year_expense) + Number(year_receive_paidamount)}`,
      },
    ];

    const dataBalance = [
      {
        name: "Today's Balance",
        expence: `${
          Number(today_income) +
          Number(today_sell_paidamount) +
          Number(todaycollectedfee) -
          Number(today_expense)
        }`,
      },
      {
        name: "Last 7 days Balance",
        expence: `${
          Number(week_income) +
          Number(week_sell_paidamount) +
          Number(lastweekcollectedfee) -
          Number(week_expense)
        }`,
      },
      {
        name: "Current Month Balance",
        expence: `${
          Number(month_income) +
          Number(month_sell_paidamount) +
          Number(lastmonthcollectedfee) -
          Number(month_expense)
        }`,
      },
      {
        name: "Last 6 Month Balance",
        expence: `${
          Number(sixmonth_income) +
          Number(sixmonth_sell_paidamount) +
          Number(halfyearlycollectedfee) -
          Number(sixmonth_expense)
        }`,
      },
      {
        name: "Current Year Balance",
        expence: `${
          Number(year_income) +
          Number(year_sell_paidamount) +
          Number(yearlycollectedfee) -
          Number(year_expense)
        }`,
      },
    ];

    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header to="/home" title="Accounts Dashboard" />
        <div className="container my-3 col-12">
          <>
            <div className="th-15 th-bold th-primary mb-1">Income</div>
            <div className="d-flex  flex-wrap">
              {dataIncome?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 th-primary">
                            <span className="th-roboto">₹</span>
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="th-15 th-bold th-primary mb-1 mt-4">Expense</div>
            <div className="d-flex  flex-wrap">
              {dataExpense?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 th-primary">
                            <span className="th-roboto">₹</span>
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="th-15 th-bold th-primary mb-1 mt-4">
              Balance
            </div>
            <div className="d-flex  flex-wrap">
              {dataBalance?.map((item, index) => {
                return (
                  <div className="col-6 px-1">
                    <div
                      style={{ height: "100%" }}
                      className="shadow-sm p-2 mt-2"
                    >
                      {loading ? (
                        <>
                          <Skeleton />
                          <Skeleton width={50} />
                        </>
                      ) : (
                        <>
                          <div className="th-12">{item.name}</div>{" "}
                          <div className="th-16 th-primary">
                            <span className="th-roboto">₹</span>
                            {item.expence}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(Notificaations);
